export default __webpack_public_path__ + "static/media/product-tour5.976dc898.svg";